module.exports = __webpack_public_path__ + "img/ico_CD.bd16de83.png";